import Indicador from "..";

import { LCParamFields } from "./components/LCParamFields";
import LCEditFields from "./components/LCEditFields";

import lcReportSummary from "./reports/summary";
import lcReport from "./reports";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";
// import LCGraficoExtraPainel from "./components/LCGraficoExtraPainel"
// import LCGraficoExtraRelatorio from "./components/LCGraficoExtraRelatorio"

export default class LC extends Indicador {
    static get fullName() {
        return "Levantamento de Cigarrinhas";
    }

    static get abbrev() {
        return "LC";
    }

    static get quantifierMeta() {
        return "QT";
    }

    static get legacyApontamentoMap() {
        return {
            dataHoraLC: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            // trator: "trator",
            // seletorImplementoLC: "implemento",
            // frente: "frente",

            coletasLC: {
                type: Array,
                newField: "coletas",
                children: {
                    numNinfas: "numNinfas",
                    numAdultas: "numAdultas",
                    conforme: "conforme",
                    observacao: "observacao",
                    foto: {
                        newField: "image.uid",
                        convert: this.convertLegacyImageUid,
                    },
                    confirmaRelatorio: "confirmaRelatorio",
                    "foto.georeferencia": "georeferencia",
                    georeferencia: "georeferencia",
                },
            },

            conformidadeAmostra: "conformidade",

            observacaoAmostraLC: "observacao",

            itensColetaLC: "images",
        };
    }

    static get legacyParamMap() {
        return {
            GVMinimoManual: "manual.intervaloMin",
            GVMaximoManual: "manual.intervaloMax",
            metroPontoAvaliadoManual: "manual.metroPontoAvaliado",
            valorMetaLCManual: "manual.meta",

            GVMinimoMecanizado: "mecanizado.intervaloMin",
            GVMaximoMecanizado: "mecanizado.intervaloMax",
            metroPontoAvaliadoMecanizado: "mecanizado.metroPontoAvaliado",
            valorMetaLCMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = "") {
        return <LCParamFields tipoIndicadorField={tipoIndicadorField} />;
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <LCEditFields visita={visita} TipoClass={TipoClass} />;
    }

    // static getGraficoExtraPainel(indicadorProps, nomeAgrupador) {
    //     return <LCGraficoExtraPainel indicadorProps={indicadorProps} nomeAgrupador={nomeAgrupador} />
    // }

    // static getGraficoExtraRelatorio(content, h, mediaAgrupadorList, metaUsar, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim) {
    //     return LCGraficoExtraRelatorio(content, h, mediaAgrupadorList, metaUsar, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim)
    // }

    async renderReport(visita) {
        return lcReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return lcReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const totalNumColetas = apontamento.coletas.length;
        let totalNumNinfas = 0;
        let totalNumAdultas = 0;

        for (const coleta of apontamento.coletas) {
            if (coleta.numNinfas) {
                totalNumNinfas = totalNumNinfas + f(coleta.numNinfas);
                coleta.numNinfasMetro = f(coleta.numNinfas) / f(params.metroPontoAvaliado);
                coleta.numNinfasMetro = f(coleta.numNinfasMetro).toFixed(2);
            }
            if (coleta.numAdultas) {
                totalNumAdultas = totalNumAdultas + f(coleta.numAdultas);
                coleta.numAdultasMetro = f(coleta.numAdultas) / f(params.metroPontoAvaliado);
                coleta.numAdultasMetro = f(coleta.numAdultasMetro).toFixed(2);
            }
            coleta.numOcorrencias = f(coleta.numAdultas) + f(coleta.numNinfas);
        }

        apontamento.numAdultasMetro = f(totalNumAdultas) / (f(params.metroPontoAvaliado) * totalNumColetas);
        apontamento.totalNumAdultas = totalNumAdultas;

        apontamento.totalNumNinfas = totalNumNinfas;
        return (apontamento.numNinfasMetro = f(totalNumNinfas) / (f(params.metroPontoAvaliado) * totalNumColetas));
    }

    static getConformidadeStatus(conformidade, meta) {
        if (conformidade <= parseFloat(meta)) {
            return "Bom";
        } else {
            return "Ruim";
        }
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.numNinfas + coleta.numAdultas)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: "auto", getValue: (a) => a.dataRef.split("-").reverse().join("/") },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: "auto" },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            {
                title: "Talhão",
                field: "talhao.nome",
                getValue: (a) => getTalhaoNomeDisplay(a),
            },
            {
                title: "Área (ha)",
                field: "talhao.area",
                getValue: (a) => getTalhaoAreaDisplay(a),
            },
            { title: "Variedade", field: "variedade.variedade", width: "auto" },

            { title: "Qtd. Adultas", width: "auto", field: "totalNumAdultas" },
            {
                title: "Adultas/M",
                field: "numAdultasMetro",
                width: "auto",
                getColor: (a) => {
                    return IndicadorClass.getColorStatus(
                        IndicadorClass.getConformidadeStatus(a.numAdultasMetro, paramsCliente?.metaMaxAdultas),
                    );
                },
            },
            { title: "Qtd. Ninfas", width: "auto", field: "totalNumNinfas" },
            {
                title: "Ninfas/Metro",
                field: "conformidade",
                width: 55,
                getColor: (a) => {
                    return IndicadorClass.getColorStatus(
                        IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta),
                    );
                },
            },
        ];
    }

    static getResultStr(apontamento) {
        return (
            "Qtd. Adultas: " +
            apontamento.totalNumAdultas +
            ", Adultas/M: " +
            apontamento.numAdultasMetro +
            " e Qtd. Ninfas: " +
            apontamento.totalNumNinfas
        );
    }
}
